import { type FC } from 'react';

import { headerStyle } from '../styles';
import { DeletedBadge } from '../../Badge';
import { Badge } from 'react-bootstrap';

interface Props {
	title: string;
	movedTo?: string;
	styles: string;
}

const DeletedItem: FC<Props> = (props) => {
	const { title, movedTo, styles } = props;

	return (
		<div className={`${headerStyle} ${styles} `}>
			<span className="title">{title}</span>
			{movedTo ? <Badge variant="danger">moved to {movedTo}</Badge> : <DeletedBadge />}
		</div>
	);
};

export default DeletedItem;
